module.exports = __webpack_public_path__ + "img/plus-mini.cb3fdeda.svg";